import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService, CommonService, CommonAPIService } from '../../../services';
import { Subscription } from 'rxjs';
import { Paths } from '../../../enums';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-sub-category-course',
  standalone: false,
  templateUrl: './sub-category-course.component.html',
  styleUrl: './sub-category-course.component.scss'
})
export class SubCategoryCourseComponent {
  courseSubCategoryData: any[] = [];
  coursesCategoryId: any;
  imageUrl: string = environment.imageURL;

  constructor(
    private sharedService: SharedService,
    private commonService: CommonService,
    private commonAPIService: CommonAPIService,
    private router: Router,
  ) { }

  ngOnInit() {
    let getSubCategoryCourseData = this.commonAPIService.data;
    if (getSubCategoryCourseData) {
      this.coursesCategoryId = getSubCategoryCourseData.coursesCategoryId;
      this.getSubCategoryCourseData();
    }
    if (!getSubCategoryCourseData) {
      const storedData = localStorage.getItem('serviceData');
      if (storedData) {
        getSubCategoryCourseData = JSON.parse(storedData);
        this.coursesCategoryId = getSubCategoryCourseData.coursesCategoryId;
        this.getSubCategoryCourseData();
      }
    }
  }

  async getSubCategoryCourseData() {
    try {
      this.sharedService.setApiCall(true);
      this.commonService.resetAPIFlag('getSubCategoryCourses', false);
      const response: any = await this.commonAPIService.getCall('getSubCategoryCourses', this.coursesCategoryId);
      this.commonService.resetAPIFlag('getSubCategoryCourses', false);
      switch (response.status) {
        case 1:
          if (response.data) {
            this.courseSubCategoryData = response?.data;
            this.sharedService.setApiCall(false);
          }
          else {
            this.courseSubCategoryData = [];
            this.sharedService.setApiCall(false);
          }
          break;
        case 0:
          this.courseSubCategoryData = [];
          this.sharedService.setApiCall(false);
          break;
      }
    } catch (error) {
      console.error('Error getting Courses details:', error);
    }
  }

  getCourse(item: any) {
    this.commonAPIService.data = item;
    localStorage.setItem('serviceData',JSON.stringify(item));
    this.router.navigate([`${Paths.course}`]);
  }

  ngOnDestroy(): void { }
}
